import { render, staticRenderFns } from "./TargetedSMS.vue?vue&type=template&id=6bddd0ec&scoped=true&"
import script from "./TargetedSMS.vue?vue&type=script&lang=js&"
export * from "./TargetedSMS.vue?vue&type=script&lang=js&"
import style0 from "./TargetedSMS.vue?vue&type=style&index=0&id=6bddd0ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bddd0ec",
  null
  
)

export default component.exports